import React from 'react';
import {
  FaCheckCircle,
  FaClock,
  FaExclamationCircle,
  FaBan,
  FaHourglassEnd,
  FaExclamationTriangle,
} from 'react-icons/fa';

export const STATUS_CONFIG = {
  primary: {
    color: '#F5B041',
    icon: <FaClock color="#F5B041" />,
  },
  warning: {
    color: '#F5B041',
    icon: <FaCheckCircle color="#F5B041" />,
  },
  success: {
    color: '#2ECC71',
    icon: <FaCheckCircle color="#2ECC71" />,
  },
  danger: {
    color: '#E74C3C',
    icon: <FaBan color="#E74C3C" />,
  },
  info: {
    color: '#2ECC71',
    icon: <FaCheckCircle color="#2ECC71" />,
  },
};

export const STATUSES = [
  {
    id: 'recebido',
    label: 'Recebido',
    color: '#2ECC71',
    icon: <FaCheckCircle color="#2ECC71" />,
    apiStatus: ['Recebido', 'Paga', 'Recebida'],
  },
  {
    id: 'marcado_c_recebido',
    label: 'Marcado c/ recebido',
    color: '#3498DB',
    icon: <FaCheckCircle color="#3498DB" />,
    apiStatus: ['Marcado c/ recebido'],
  },
  {
    id: 'a_receber',
    label: 'A receber',
    color: '#F5B041',
    icon: <FaClock color="#F5B041" />,
    apiStatus: ['A receber', 'Pendente', 'Aguardando pagamento'],
  },
  {
    id: 'atrasado',
    label: 'Atrasado',
    color: '#E67E22',
    icon: <FaExclamationTriangle color="#E67E22" />,
    apiStatus: ['Atrasado', 'Vencida'],
  },
  {
    id: 'expirado',
    label: 'Expirado',
    color: '#7F8C8D',
    icon: <FaHourglassEnd color="#7F8C8D" />,
    apiStatus: ['Expirado'],
  },
  {
    id: 'cancelado',
    label: 'Cancelado',
    color: '#E74C3C',
    icon: <FaBan color="#E74C3C" />,
    apiStatus: ['Cancelado', 'Cancelada'],
  },
  {
    id: 'protesto',
    label: 'Protesto',
    color: '#8E44AD',
    icon: <FaExclamationCircle color="#8E44AD" />,
    apiStatus: ['Protesto'],
  },
];

export default STATUSES;
